import React from "react";
/* eslint-disable @next/next/no-img-element */

const FooterHomeNew = () => {
  return (
    <footer className="footer">
      <ul className="footer-links">
        <li className="footer-link">
          <a href="/">Chippy</a>
        </li>
        <img alt="Chippy clip icon" src="/clip.svg" />
        <li className="footer-link">
          <a href="/privacy">Privacy Policy</a>
        </li>
        <img alt="Chippy clip icon" src="/clip.svg" />
        <li className="footer-link">
          <a href="https://chrome.google.com/webstore/detail/chippy-%E2%80%94-chatgpt-at-your/fbcdphjbmledkhefgamfaleobmegjojl/support">Support</a>
        </li>
        <img alt="Chippy clip icon" src="/clip.svg" />
        <li className="footer-link">
          <a>Not Affiliated with Microsoft</a>
        </li>
      </ul>

      {/* <p className="mobile-only footer-warning">
        Chippy is compatible exclusively on computers and is not available for
        mobile devices.
      </p> */}
    </footer>
  );
};

export default FooterHomeNew;
